import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgCashDrawerSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 15.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H9Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.003 8.602c.014.05.026.099.036.148h.461a.75.75 0 0 1 .702.487l1.5 4a.75.75 0 0 1 .048.264v6a.75.75 0 0 1-.75.75H2a.75.75 0 0 1-.75-.75v-6c0-.09.016-.18.048-.264l1.5-4A.75.75 0 0 1 3.5 8.75h.496a2.75 2.75 0 0 1 1.945-3.368l9.66-2.588a2.75 2.75 0 0 1 3.367 1.944l1.035 3.864Zm.915 4.149h-5.772l2.913-.781a2.747 2.747 0 0 0 1.874-1.72h.047l.938 2.5ZM4.02 10.25h.378l.634 2.363c.012.046.025.091.04.136h-1.99l.938-2.5Zm17.23 4H2.75v4.5h18.5v-4.5Zm-4.709-6.016a.75.75 0 1 0-.388-1.449l-.242.065A.75.75 0 1 0 16.3 8.3l.241-.065Zm-8.693 2.33a.75.75 0 1 0-.389-1.45l-.241.065a.75.75 0 0 0 .388 1.45l.242-.065Zm6.084-2.407a2 2 0 1 1-3.863 1.035 2 2 0 0 1 3.863-1.035Z",
  fill: "currentColor"
})));

export { SvgCashDrawerSolid as default };
